import { Tag } from "antd";
import moment from "moment";

export const PendingAdminColumns = ({
  reject = (f) => f,
  approve = (f) => f,
}) => [
  {
    title: "Full Name",
    render: (record) => {
      return (
        <span>
          {record.firstName} {record.lastName}
        </span>
      );
    },
    ellipsis: true,
  },
  {
    title: "Email",
    dataIndex: "email",
    ellipsis: true,
  },
  {
    title: "Request Status",
    dataIndex: "status",
    render: (status) => {
      return (
        <Tag
          style={{
            color: "#6e6d6d",
            border: "none",
          }}
        >
          {status.toLowerCase() === "pending" ? "Pending Approval" : status}
        </Tag>
      );
    },
  },
  {
    title: "Date Requested",
    dataIndex: "createdAt",
    render: (createdAt) => moment(createdAt).format("YYYY-MM-DD HH:mm"),
    ellipsis: true,
  },
  {
    title: "Action",
    render: (record) => (
      <div style={{ display: "flex", gap: "8px" }}>
        <button
          onClick={() => approve(record.id)}
          style={{
            backgroundColor: "#27AE60",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "4px 12px",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "background 0.2s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#219653")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#27AE60")
          }
        >
          Approve
        </button>

        <button
          onClick={() => reject(record.id)}
          style={{
            backgroundColor: "#EB5757",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "4px 12px",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "background 0.2s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#c52828")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#EB5757")
          }
        >
          Reject
        </button>
      </div>
    ),
  },
];
